import DesignLinkButton from 'components/button/DesignLinkButton';
import { DownloadIcon } from 'components/svgs';

/**
 * Served as static assets from the app root (see `public/templates`), so the
 * href is built from `PUBLIC_URL` rather than a relative path: the page lives
 * under `/:countryCode/capacity-planning`, and a relative href would resolve
 * under that country prefix instead of the root.
 */
export const templateFiles = [
  {
    label: 'Agency template (CSV)',
    fileName: 'capacity-plan-agency-template.csv',
  },
  {
    label: 'Network template (CSV)',
    fileName: 'capacity-plan-network-template.csv',
  },
];

export interface TemplateDownloadsProps {
  /** Highlights the template that matches the Run being created. */
  isNetworkRun?: boolean;
}

/** Download links for the blank Agency Run and Network Run templates. */
const TemplateDownloads = ({ isNetworkRun }: TemplateDownloadsProps) => {
  const highlighted = isNetworkRun
    ? 'capacity-plan-network-template.csv'
    : 'capacity-plan-agency-template.csv';

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs text-light-black dark:text-sublte-white">
        Need a template?
      </span>
      <div className="flex gap-2">
        {templateFiles.map(({ label, fileName }) => (
          <DesignLinkButton
            key={fileName}
            href={`${process.env.PUBLIC_URL}/templates/${fileName}`}
            download={fileName}
            variant={fileName === highlighted ? 'primary' : 'secondary'}
            size="sm"
          >
            <DownloadIcon className="h-4 w-4" />
            {label}
          </DesignLinkButton>
        ))}
      </div>
      <p className="text-xs text-light-black dark:text-sublte-white">
        Required columns: Agency, Address, Town, Village, County, Latitude,
        Longitude, DepotLatitude, DepotLongitude, DeliveryId, DeliveryTime,
        ParkingTime, ApproximateLocationAdditionalTime, IsApproximated.
        Optional: RecipientPhone. Leave both delivery coordinates empty to
        geocode a row from its address.
      </p>
    </div>
  );
};

TemplateDownloads.defaultProps = {
  isNetworkRun: false,
};

export default TemplateDownloads;
